<div class="group-container">
  <div class="email-button-container">
    <app-input-field
      [ngClass]="{ 'button-width': showPreferredButtons }"
      [label]="sysText.workEmail"
      [ariaLabel]="ariaLabelPrefix ? ariaLabelPrefix + ' ' + sysText.workEmail : null"
      [control]="workEmailControl"
      [group]="group"
      [autocomplete]="autocomplete"
      [hideIconSpace]="hideIconSpace"
      [icon]="!hideIcon ? 'email' : ''">
    </app-input-field>
    @if (showPreferredButtons) {
      <div class="button-container">
        <mat-button-toggle-group
          (change)="onPreferredClick($event)">
          <mat-button-toggle
            class="preferred-email-option"
            [value]="preferredEmail.Work"
            [checked]="isWorkEmailPreferredControl.value"
            [aria-label]="sysText.preferred_message | capitalizefirst"
            [matTooltip]="sysText.preferred_message | capitalizefirst"
            [matTooltipShowDelay]="500"
            matTooltipPosition="above">
            <mat-icon [ngClass]="{ 'selected': isWorkEmailPreferredControl.value }">stars</mat-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    }
  </div>
  <div class="email-button-container">
    <app-input-field
      [ngClass]="{ 'button-width': showPreferredButtons }"
      [label]="sysText.personalEmail"
      [ariaLabel]="ariaLabelPrefix ? ariaLabelPrefix + ' ' + sysText.personalEmail : null"
      [control]="personalEmailControl"
      [hideIconSpace]="hideIconSpace"
      [group]="group"
      [autocomplete]="autocomplete">
    </app-input-field>
    @if (showPreferredButtons) {
      <div class="button-container">
        <mat-button-toggle-group
          (change)="onPreferredClick($event)">
          <mat-button-toggle
            class="preferred-email-option"
            [value]="preferredEmail.Personal"
            [checked]="isPersonalEmailPreferredControl.value"
            [aria-label]="sysText.preferred_message | capitalizefirst"
            [matTooltip]="sysText.preferred_message | capitalizefirst"
            [matTooltipShowDelay]="500"
            matTooltipPosition="above">
            <mat-icon [ngClass]="{ 'selected': isPersonalEmailPreferredControl.value }">stars</mat-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    }
  </div>
</div>